import store from "@/store"

export default {
    get application() {
        return store.state.application.data
    },

    set application(application) {
        store.commit("application/update", application)
    },

    get applyMode() {
        return store.state.application.applyMode
    },

    get resume() {
        return store.state.application.resume
    },

    get primaryLenderApplyMode() {
        return store.state.application.primaryLenderApplyMode
    },

    get selectedPaymentPlan() {
        return store.state.application.selectedPaymentPlan
    },

    get isPatient() {
        return store.state.application.isPatient
    },

    set applyMode(mode) {
        store.commit("application/updateApplyMode", mode)
    },

    set selectedPaymentPlan(plan) {
        store.commit("application/updateSelectedPaymentPlan", plan)
    },

    set primaryLenderApplyMode(mode) {
        store.commit("application/updatePrimaryLenderApplyMode", mode)
    },

    set resume(resume) {
        store.commit("application/updateResume", resume)
    },

    set isPatient(type) {
        store.commit("application/updateIsPatient", type)
    }
}
